import React from "react";
import { useNavigate } from "react-router-dom";
import SettingsIcon from "../../../assets/icons/SettingsIcon";
import styles from "../AssistantTestModule.module.scss";
import {
  setActiveAssistant,
  setUpdateAssistant,
} from "../../../store/slices/assistantSlice";
import { useDispatch, useSelector } from "react-redux";
import { setActiveDialog } from "../../../store/slices/dialogSlice";
export const LeftHeader = ({
  assistantId,
  assistantName,
  section,
  openSettings,
  setOpenSettings,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { dataAssistants } = useSelector((state) => state.assistant);

  const handleGoToAssistant = () => {
    const assistant = dataAssistants.find(
      (assistant) => assistant.id === assistantId
    );
    dispatch(setActiveDialog(null));
    dispatch(setUpdateAssistant(null));
    dispatch(setActiveAssistant(assistant));
    localStorage.setItem("activeAssistant", JSON.stringify(assistant));
    navigate(`/${section}`);
  };

  const handleGoToAssistants = () => {
    navigate(`/${section}`);
    dispatch(setActiveDialog(null));
    dispatch(setUpdateAssistant(null));
  };

  return (
    <div className={styles.leftHeader}>
      <nav className={styles.breadcrumb}>
        <span className={styles.breadcrumbLink} onClick={handleGoToAssistants}>
          Ассистенты
        </span>
        <span>/</span>
        <span className={styles.breadcrumbLink} onClick={handleGoToAssistant}>
          {assistantName}
        </span>
        <span>/</span>
        <span style={{ color: "#212121" }}>Тестирование</span>
      </nav>
      <div
        className={styles.settings}
        onClick={() => setOpenSettings(!openSettings)}
      >
        <SettingsIcon size={20} fill={"#212121"} />
      </div>
    </div>
  );
};
